var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0H10.8333V9.16667H20V0ZM15.8333 1.66667H13.3333V2.50001H15V6.66667H15.8333L15.8333 1.66667ZM13.3333 7.50001V6.66668H17.5V7.50001H13.3333ZM9.16667 10.8333H0V20H9.16667V10.8333ZM7.50005 12.5H1.66672V13.3333H7.50005V15L2.50005 15L2.50004 15.8333H1.6667V17.5V18.3333H8.33337V17.5L2.50004 17.5V15.8333L7.50005 15.8333V15H8.33338V13.3333H7.50005L7.50005 12.5ZM10.8333 20V10.8333H20V20H10.8333ZM12.5 13.3333V12.5H17.5L17.5 13.3333H12.5ZM17.5 15V13.3333L18.3333 13.3333V15H17.5ZM17.5 15.8333L14.1667 15.8333V15L17.5 15L17.5 15.8333ZM17.5 17.5L17.5 15.8333H18.3333V17.5H17.5ZM17.5 17.5V18.3333H12.5V17.5L17.5 17.5ZM0 0H9.16667V9.16667H0V0ZM2.07357 1.22396H2.7474L4.57357 6.44369L6.39974 1.22396H7.07357H7.63997H8.3138V8.33333H6.84896V6.31185L6.99472 3.01006L5.07161 8.33333H4.07552L2.15242 3.01006L2.29818 6.31185V8.33333H0.838216V1.22396H1.50716H2.07357Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarco);
export default __webpack_public_path__ + "static/media/Marco.34f9c284d7a833ce4f8b154b00073947.svg";
export { ForwardRef as ReactComponent };